import { render, staticRenderFns } from "./AwardInfoModal.vue?vue&type=template&id=2aed732f&scoped=true"
var script = {}
import style0 from "./AwardInfoModal.vue?vue&type=style&index=0&id=2aed732f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed732f",
  null
  
)

export default component.exports